import { render, staticRenderFns } from "./WebChatHistory.vue?vue&type=template&id=a69d24cc&scoped=true&"
import script from "./WebChatHistory.vue?vue&type=script&lang=js&"
export * from "./WebChatHistory.vue?vue&type=script&lang=js&"
import style0 from "./WebChatHistory.vue?vue&type=style&index=0&id=a69d24cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69d24cc",
  null
  
)

export default component.exports